import { render, staticRenderFns } from "./FormControlProductTypesButtons.vue?vue&type=template&id=1c527c76"
import script from "./FormControlProductTypesButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlProductTypesButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports